import React from 'react';
import {Ping} from "./ServerSelectorBtn";

export const Server = ({
    server,
    isBtn,
    activeServerId,
    setActiveServer
}) => {
    const containerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        fontFamily: '"VK Sans Display", sans-serif',
        padding: '16px',
        ...((!isBtn) ? {
            borderBottom: '1px solid rgba(255, 255, 255, 0.15)'
        } : {}),
        ...((!isBtn && activeServerId === server.server_id) ? {
            backgroundColor: '#2D2F31',
            transition: '0.5s all'
        } : {})
    };

    const handleClick = () => {
        if (isBtn) return;
        if (setActiveServer) setActiveServer(server.server_id);
    };

    return (
        <div style={containerStyle} onClick={handleClick}>
            <div style={{display: 'flex', gap: "10px", alignItems: 'center'}}>
                <img src={server.image_url} alt={server.server_name} style={{width: 32, height: 24, borderRadius: 4}}/>
                <h1 style={{fontSize: "16px", lineHeight: "24px", fontWeight: "400"}}>{server.server_name}</h1>
            </div>
            <div style={{display: 'flex', gap: 12, alignItems: "center"}}>
                <Ping pingMs={server.ping}/>
                {isBtn &&
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M1.83594 6.91274L3.16176 5.58691L9.99885 12.424L16.8359 5.58691L18.1618 6.91274L9.99885 15.0757L1.83594 6.91274Z"
                              fill="white" fillOpacity="0.3"/>
                    </svg>}
            </div>
        </div>
    );
}